<template>
  <div class="date-label-container">
    <div class="date-time-container"></div>
    <div class="date-day-text">{{this.current}}</div>
    <div class="date-month-text">{{this.length}}</div>
    <div style="width:100%;margin:auto 0 auto 7px ">
      <van-progress stroke-width="8px" :show-pivot="false" color="#3994E7" :percentage="progress" />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import _ from "lodash";
import { WEEKDAY_MAPPING } from "@/contants/time";

export default {
  name: "AnswerProgress",
  props: {
    current: {
      type: Number,
      default: 0,
    },
    length: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      //   date: "",
    };
  },
  computed: {
    progress(){
      return (this.current / this.length) * 100
    },
    dateTimeDay() {
      return moment(this.date).format("DD");
    },
    dateTimeMonth() {
      return moment(this.date).format("MM");
    },
    weekday() {
      return _.get(WEEKDAY_MAPPING, moment(this.date).day());
    },
  },
};
</script> 
<style lang="stylus" rel="stylesheet/stylus" scoped>
.date-label-container {
  padding-left: 3vw;
  margin: 0 0 12px 0;
  display: flex;
  position: relative;
  height: 30px;
  flex-direction: row;
}

.date-day-text {
  position: absolute;
  top: -1px;
  left: 0px;
  font-size: 14px;
  color: #333333;
  font-family: pangmeng;
}

.date-month-text {
  position: absolute;
  bottom: 0px;
  left: 20px;
  font-size: 14px;
  color: #999999;
  font-family: pangmeng;
}

.date-time-container {
  // background-color :green
  margin-left: -10px;
  margin-top: 15px;
  height: 0px;
  border-bottom: 1px solid #333333;
  width: 32px;
  transform: rotateZ(145deg);
  -o-transform: rotate(145deg);
  -moz-transform: rotate(145deg);
  -webkit-transform: rotate(145deg);
}

.date-week-container {
  margin-left: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #333333;
  // margin-bottom :
}

.date-week-text {
  text-align: center;
  padding: 2px 1px;
  width: 14px;
  line-height: 12px;
  font-size: 6px;
  font-family: serif,SimSun,STSong;
}
</style>


// WEBPACK FOOTER //
// app/pages/article/component/AnswerProgress.vue